import { ExperimentName, ExperimentCookieName, ExperimentValue, type CoreExperiment, type ExperimentCookieNameUnion } from '@core/types'

export default defineNuxtRouteMiddleware((to) => {
    const { experiments } = useCoreConfig()

    const cleanupInactiveExperiments = () => {
        const possibleExperiments = Object.values(ExperimentCookieName)
        const activeExperiments = experiments?.length
            ? experiments?.reduce((acc: ExperimentCookieNameUnion[], experiment: CoreExperiment) => {
                    acc.push(experiment.cookieName)

                    return acc
                }, [])
            : []

        possibleExperiments.forEach((cookieName) => {
            const isActiveExperiment = activeExperiments?.includes(cookieName)

            // Don't remove active experiments
            if (isActiveExperiment) return

            const experimentCookie = useCookie(cookieName)

            if (experimentCookie.value) {
                experimentCookie.value = null
            }
        })
    }

    if (import.meta.client) {
        cleanupInactiveExperiments()
    }

    if (useIsKnownCrawler().value) return

    if (!experiments?.length) return

    // Set cookie for each active experiment
    experiments.forEach((experiment: CoreExperiment) => {
        // Prevent setting cookie for empty required experiments
        if (!experiment?.versions?.[ExperimentValue.A] || !experiment?.versions?.[ExperimentValue.B]) return

        // Selection (needsAuthentication, userId, random) lives in useExperiment.
        useExperiment({
            cookieName: experiment.cookieName,
            experimentName: experiment.name,
            allowWrite: true,
            override: experimentOverride(to.query, experiment.name),
        })
    })
})
